<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'yichangAuditList',
})
</script>
<template>
    <a-card :bordered="false">
        <div class="table-page-search-wrapper">
            <a-form>
                <a-row :gutter="48">
                    <a-col :md="6" :sm="24">
                        <a-form-item label="主体名称" name="nameOrCode">
                            <a-input @keyup.enter="loadData" v-model:value="queryParam.nameOrCode"
                                placeholder="请输入主体名称、税号"> </a-input>
                        </a-form-item>
                    </a-col>
                    <a-col :md="6" :sm="24">
                        <a-form-item label="平台名称" name="platform_id">
                            <a-select allow-clear mode="multiple" v-model:value="queryParam.platform_id"
                                placeholder="请选择平台">
                                <a-select-option v-for="(item, index) in state.platformList" :key="index"
                                    :value="item.id">{{ item.platform_abbreviation }}</a-select-option>
                            </a-select>
                        </a-form-item>
                    </a-col>
                    <a-col :md="6" :sm="24">
                        <a-form-item label="状态" name="status">
                            <a-select allow-clear mode="multiple" v-model:value="queryParam.status" placeholder="请选择">
                                <a-select-option :value="0">待审核</a-select-option>
                                <a-select-option :value="1">已锁定</a-select-option>
                                <a-select-option :value="2">取消锁定</a-select-option>
                            </a-select>
                        </a-form-item>
                    </a-col>
                    <a-col :md="6" :sm="24">
                        <a-form-item label="锁定理由" name="reason">
                            <a-input @keyup.enter="loadData" v-model:value="queryParam.reason" placeholder="请输入">
                            </a-input>
                        </a-form-item>
                    </a-col>
                    <a-col :md="6" :sm="24">
                        <a-form-item label="录入系统时间" name="between_time">
                            <a-range-picker :show-time="{ defaultValue: arrayMonent }" :value="rangTime"
                                @change="rangTimeChange" :format="format"></a-range-picker>
                        </a-form-item>
                    </a-col>
                    <a-col :md="6" :sm="24">
                        <div class="table-page-search-submitButtons" style="overflow: hidden; margin-bottom: 0">
                            <a-button type="primary" @click="loadData">查询</a-button>
                        </div>
                    </a-col>
                </a-row>
            </a-form>
        </div>
        <a-table :columns="columns" :loading="state.loading" :data-source="dataSource" :pagination="pagination"
            @change="onChange" size="small">
            <template #bodyCell="{ column, record, index, text }">
                <template v-if="column.dataIndex === 'name'">
                    <p>{{ record.full_name }}</p>
                    <div style="font-size: 11px">代理商：{{ record.seller }}</div>
                    <div style="font-size: 11px">入驻地址：{{ record.full_address_number }}</div>
                    <a @click="goCustomerClick(record.full_name)" class="pointer"> 查看详情 </a>
                </template>
                <template v-else-if="column.dataIndex === 'lockInfo'">
                    <a-tag color="blue" v-if="record.status == 0">待审核</a-tag>
                    <a-tag color="green" v-if="record.status == 1">已锁定</a-tag>
                    <a-tag color="red" v-if="record.status == 2">取消锁定</a-tag>
                    <div>锁定时间：{{ record.start_time }} - {{ record.end_time }}</div>
                    <div>理由：{{ record.reason }}</div>
                    <div v-if="record.url && record.url.length > 0">
                        附件：
                        <template v-for="(item, index) in record.url">
                            <a-image v-if="item.endsWith('png') || item.endsWith('jpg') || item.endsWith('jpeg')"
                                :width="60" :height="60" :key="index"
                                :src="$store.state.user.image_domain + item"></a-image>
                        </template>
                    </div>
                    <div>备注：{{ record.remark }}</div>
                </template>

                <template v-else-if="column.dataIndex === 'unlockInfo'">
                    <div>审核备注:{{ record.audit_remark }}</div>
                    <div v-if="record.audit_url && record.audit_url.length > 0">
                        附件：
                        <template v-for="(item, index) in record.audit_url">
                            <a-image v-if="item.endsWith('png') || item.endsWith('jpg') || item.endsWith('jpeg')"
                                :width="60" :height="60" :key="index"
                                :src="$store.state.user.image_domain + item"></a-image>
                        </template>
                    </div>
                </template>
                <template v-else-if="column.dataIndex === 'action'">
                    <div v-if="record.status == 0">
                        <a-input v-model:value="record.desc" placeholder="选填:输入通过或者不通过的理由"></a-input>
                        <a-popconfirm title="确定不通过?" @confirm="verificatioChange(record, 2)">
                            <a-button class="mr-1x mt-1x" type="primary" danger>不通过</a-button>
                        </a-popconfirm>
                        <a-popconfirm title="确定通过?" @confirm="verificatioChange(record, 1)">
                            <a-button type="primary">通过</a-button>
                        </a-popconfirm>
                    </div>
                    <div v-else-if="record.status == 1">
                        <a-button type="primary" size="small" @click="cancelLock(record)">取消锁定</a-button>
                    </div>
                </template>
            </template>
        </a-table>
        <CancelLockException v-if="state.cancelVisible" :detailData="state.detailData" @cancel="handleCancel"
            @ok="handleOk">
        </CancelLockException>
    </a-card>
</template>
<script lang="ts" setup name="yichangAuditList">
import type { PaginationProps } from 'ant-design-vue'
import { useRouter } from 'vue-router'
import { message, Modal, Table } from 'ant-design-vue'
import baseService from '@/utils/http/axios'
import { unref, ref, reactive, h, onMounted, computed, onActivated, customRef } from 'vue'
import dayjs from 'dayjs'
import ls from '@/utils/Storage'
import { costByPoints } from '@logicflow/core/types/util'
import { useStore } from 'vuex'
const $store = useStore()
const arrayMonent = [dayjs('00:00:00', 'HH:mm:ss'), dayjs('23:59:59', 'HH:mm:ss')]
import CancelLockException from './components/CancelLockException.vue'
const token = ls.get('ACCESS_TOKEN').replace('Bearer ', '')
const user = ls.get('USER_INFO')
const router = useRouter()
const format = 'YYYY-MM-DD HH:mm:ss'

interface data {
    visible: boolean
    loading: boolean
    platformList: any[]
    detailData: any
    cancelVisible: boolean
}
const state = reactive<data>({
    visible: false,
    loading: false,
    platformList: [],
    detailData: {},
    cancelVisible: false
})
const columns = [
    {
        title: '公司名称',
        dataIndex: 'name',
        width: 300
    },
    {
        title: '锁定信息',
        dataIndex: 'lockInfo',
        width: 400
    },
    {
        title: '取消锁定',
        dataIndex: 'unlockInfo',
        width: 400
    },
    {
        title: '申请时间',
        dataIndex: 'created_at',
        width: 200
    },
    {
        title: '操作',
        dataIndex: 'action',
        width: 200
    }
]
const formLayout = {
    labelCol: {
        xs: { span: 4 },
        sm: { span: 4 }
    },
    wrapperCol: {
        xs: { span: 16 },
        sm: { span: 16 }
    }
}
let queryParam = reactive<any>({
    order_status_list: []
})
let dataSource = ref([])
const pagination = reactive<PaginationProps>({
    pageSize: 10,
    pageSizeOptions: ['10', '20', '40', '50', '60', '200'],
    current: 1,
    total: undefined,
    showSizeChanger: true,
    showQuickJumper: true,
    showTotal: (total) => `总数：${total}`
})
onMounted(() => {
    loadData()
    platformList()
})
// 列表数据
const loadData = () => {
    if (state.loading) {
        return
    }
    state.loading = true
    // 获取到列表数据
    let requestParam = {
        url: '/admin/v1/lockExceptionList',
        method: 'post',
        data: Object.assign({ page: pagination.current, limit: pagination.pageSize }, queryParam)
    }
    baseService(requestParam)
        .then((res) => {
            state.loading = false
            pagination.total = res.data.total_records
            dataSource.value = res.data.list.map((item) => {
                if (queryParam.nameOrCode) {
                    item.fullName = item.full_name.replace(queryParam.nameOrCode, `<span style="color: red">${queryParam.nameOrCode}</span>`)
                } else {
                    item.fullName = item.full_name
                }
                return { ...item, isShowOptions: false, isShowCompany: false, desc: null, deleteType: null, customer_id: item.id }
            })
        })
        .catch((res) => {
            state.loading = false
            if (res.msg) {
                message.error(res.msg)
            } else {
                message.error('列表查询失败,请联系管理员')
            }
        })
}

// 时间选择
const rangTime = computed(() => {
    let array: any = []
    if (queryParam.between_time) {
        array = queryParam.between_time.split(',').map((item) => dayjs(item ? item : null, format))
    } else {
        array = []
    }
    return array
})
// 时间选择
const rangTimeChange = (val, str) => {
    if (val) {
        queryParam.between_time = str.join(',')
    } else {
        queryParam.between_time = null
    }
}
const goCustomerClick = (name) => {
    router.push({ path: '/customer', query: { customer_name: name } })
}

// 表格分页查询
const onChange = (val, filters) => {
    pagination.pageSize = val.pageSize
    pagination.current = val.current
    if (filters.status) {
        queryParam.order_status_list = filters.status
    }
    loadData()
}
//审核
const verificatioChange = (record, type) => {
    let requestParam = {
        url: '/admin/v1/lockException/check',
        method: 'post',
        data: {
            reason: record.desc,
            status: type,
            id: record.id
        }
    }
    baseService(requestParam)
        .then((res) => {
            message.success('操作成功')
            loadData()
        })
        .catch((res) => {
            if (res.msg) {
                message.error(res.msg)
            } else {
                message.error('操作失败,请联系管理员')
            }
        })
}
//取消锁定
const cancelLock = (record) => {
    state.detailData = record
    state.cancelVisible = true
}
const handleOk = () => {
    state.cancelVisible = false
    loadData()
}
const handleCancel = () => {
    state.cancelVisible = false
}
// 获取平台数据
const platformList = () => {
    // 获取到列表数据
    let requestParam = {
        url: '/admin/v1/platformList',
        method: 'post',
        data: { limit: 'all' }
    }
    baseService(requestParam)
        .then((res) => {
            state.platformList = res.data.list
        })
        .catch((res) => {
            if (res.msg) {
                message.error(res.msg)
            } else {
                message.error('平台列表查询失败,请联系管理员')
            }
        })
}
</script>
<style lang="less" scoped>
:deep(.ant-image) {
    margin-right: 10px;
    margin-bottom: 10px;
}

.customer-options-popover {
    p {
        padding: 0 16px;
        margin: 0;
        height: 35px;
        line-height: 35px;
        cursor: pointer;
        text-align: center;
        color: #000;
    }

    p:hover {
        color: var(--ant-primary-color);
        background: var(--ant-primary-color-deprecated-bg);
    }
}
</style>
